export const updateAccountSettings = (axiosInstance, values) => {
    const url = '/v1/account/settings';
    return axiosInstance.post(url, values);
};

export const resetPassword = (axiosInstance, email) => {
    const url = '/v1/account/forgotpassword';
    return axiosInstance.post(url, {
        email,
    });
};

export const validateResetPassword = (axiosInstance, values) => {
    const url = '/v1/account/resetpassword';
    return axiosInstance.post(url, values);
};

export const updatePassword = (axiosInstance, values) => {
    const url = '/v1/account/resetpasswordconfirm';
    return axiosInstance.post(url, values);
};

export const getAccountSettings = (axiosInstance) => {
    const url = '/v1/account/settings';
    return axiosInstance.get(url);
};

export const getFeedPreferences = (axiosInstance) => {
    const url = 'v1/preferences/feed';
    return axiosInstance.get(url);
};

export const updateFeedPreferences = (axiosInstance, values) => {
    const url = '/v1/preferences/feed';
    return axiosInstance.post(url, values);
};

export const getAustraliaSettings = (axiosInstance) => {
    const url = 'v1/account/settings/australia';
    return axiosInstance.get(url);
};

export const getLinkedAccounts = (axiosInstance) => {
    const url = 'v1/oauth/linked-accounts';
    return axiosInstance.get(url);
};

export const updateAustraliaSettings = (axiosInstance, values) => {
    const url = 'v1/account/settings/australia';
    return axiosInstance.post(url, values);
};

export const validateTennisConnectId = (axiosInstance, values) => {
    const url = `/v1/Account/settings/validatetennisconnectid/${values}`;
    return axiosInstance.get(url);
};
